<template>
    <div class="mt-3 mb-1">
        <h3 class="d-flex align-center" @click="$emit('open-and-close-tecnical-local-table')">
            {{$tc('TechnicalLocal',2)}}
            <span class="material-icons" v-if="tecnicalTableIsOpen">expand_more</span>
            <span class="material-icons" v-if="!tecnicalTableIsOpen">expand_less</span>
        </h3>
        <v-data-table
            dense
            hide-default-footer
            disable-sort
            :headers="headers"
            v-if="tecnicalTableIsOpen"
        >
            <template v-if="!actionTypeIsView" v-slot:header.addButton>
                <thead>
                    <th style="padding-left: 30%" v-if="technicalLocals.length !== 1">
                        <v-btn x-small depressed class="add-button" @click="$emit('open-tecnical-local-form')">
                        <v-icon color="#4fa2b7">add_box</v-icon>
                        </v-btn>
                    </th>
                </thead>
            </template>
            <template v-slot:body>
                <tbody>
                    <tr v-for="(item, itemIndex) in technicalLocals" :key="itemIndex" class="cursor-pointer">
                        <td>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-on="on">{{getStatusName(item.status)}}</span>
                                </template>
                                <span>{{getStatusName(item.status)}}</span>
                            </v-tooltip>
                        </td>
                        <td>{{getOwnerName(item.owner)}}</td>
                        <td>{{item.label}}</td>
                        <td v-if="!actionTypeIsView">
                            <app-datatable-action-buttons
                                :user-can-edit="true"
                                @edit="openEdit(item, itemIndex)"
                                :user-can-delete="true"
                                @delete="openDeleteDialog(itemIndex)"
                            />
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
        <app-dialog-box
            :open="deleteDialog"
            :title="$t('DeleteItem')"
            :content="$t('DeleteConfirmation') + '?'"
            :main-action-label="$t('No')"
            @mainAction="closeDeleteDialog"
            :secondary-action-label="$t('Yes')"
            @secondaryAction="deleteTecnicalLocal"
        />
    </div>
</template>

<script>
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
export default{
    name: "TechnicalLocalsTable",
    components: {
        AppDatatableActionButtons,
        AppDialogBox
    },
    props:{
        actionType: {
            type: String
        },
        technicalLocals: {
            type: Array
        },
        tecnicalTableIsOpen: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            createItemDialogIsOpen: false,
            deleteDialog: false,
            tecnicalLocalIndex: null,
            pagination: {
                sortBy: ["state"],
                descending: true,
                page: 1,
                rowsPerPage: 10
            },
        }
    },
    computed:{
        headers() {
            let headers = [
                {
                    text: this.$t('Phase'),
                    align: 'start',
                    sortable: false,
                    value: 'phase',
                    width: "30%"
                },
                {
                    text: this.$tc('Owner',1),
                    align: 'start',
                    sortable: false,
                    value: 'owner',
                    width: "25%"
                },
                {
                    text: this.$tc('Label',1),
                    align: 'start',
                    sortable: false,
                    value: 'label',
                    width: "25%"
                },
                {
                    text: null,
                    align: 'start',
                    sortable: true,
                    value: 'addButton',
                    width: "20%"
                }
            ];
            return headers;
        },
        /** Indicates if the action type is 'view' */
        actionTypeIsView() {
            return this.actionType === 'view'
        },
    },
    methods: {
        openEdit(item, index){
            this.$emit('open-edit-tecnical-local', item, index);
        },
        openDeleteDialog(itemIndex){
            this.tecnicalLocalIndex = itemIndex;
            this.deleteDialog = true;
        },
        /** Closes the delete dialog */
        closeDeleteDialog() {
            this.deleteDialog = false;
        },
        deleteTecnicalLocal(){
            this.$emit('delete-tecnical-local', this.tecnicalLocalIndex );
            this.closeDeleteDialog();
        },
        getStatusName(statusCode){
            let label;
            const projectPhases = this.$store.getters.optionLists_phase;
            projectPhases.forEach((phase)=>{
                if(phase.code === statusCode){
                    label = phase.client_label ? phase.client_label : phase.libelle
                }
            })
            return label;
        },
        getOwnerName(ownerId){
            let label;
            const owners  = this.$store.getters.getListOfOptionsByListName(
                "list_organization",
                [],
                true
            );
            owners.forEach((owner)=>{
                if(owner.or_id === ownerId){
                    label = owner.libelle
                }
            });
            return label;
        }
    }

}

</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/TechnicalLocalsTable.vue